<template>
  <div class="form-group row">
    <label class="col-md-2 col-form-label">{{kpi.name}}</label>
    <div class="col-md-8">
      <input @input="$emit('changedKpiUnit', editKpiUnit)"
             class="form-control"
             type="text"
             v-model="editKpiUnit.value"
      >
    </div>
    <label class="col-md-2 col-form-label text-right">{{kpi.unit}} hourly</label>
  </div>
</template>

<script>

  //@vuese
  // @group Products
  export default {
    name: 'ProductKpiSettings',
    props: ['kpi', 'workflowId'],
    data() {
      return {
        kpiUnit: [],
        editKpiUnit: null,
        disableNavigation: false,
        kpiUnitCopy: null
      }
    },
    firestore() {
      return {
        kpiUnit: this.$FB.collection('products').doc(this.$route.params.id)
          .collection('kpiUnits')
          .where('kpiId', '==', this.kpi.id)
          .where('workflowId', '==', this.workflowId)
      }
    },
    methods: {
      //@vueuse
      hasUnsavedChanges(event) {
        this.disableNavigation = event;
      }
    },
    watch: {
      //@vueuse
      kpiUnit: {
        handler() {
          if(this.kpiUnit.length) {
            this.editKpiUnit = this.kpiUnit[0];
            this.editKpiUnitCopy = Object.assign({}, this.editKpiUnit);
          }
        }
      },
      //@vueuse
      editKpiUnit: {
        handler(val) {
          this.$emit('unsavedChanges', JSON.stringify(val) !== JSON.stringify(this.editKpiUnitCopy));
        },
        deep: true
      }
    },
    created() {
      this.editKpiUnit = {
        workflowId: this.workflowId,
        kpiId: this.kpi.id,
        value: null
      };
      this.editKpiUnitCopy = Object.assign({}, this.editKpiUnit);
    }
  }
</script>